import { Accordion, AccordionDetails, AccordionSummary, styled, Typography } from '@material-ui/core';
import { ArrowDownward } from '@material-ui/icons';
import { accordionSummaryClasses } from '@mui/material';
import React from 'react';

type JobDetailsProps = {
    children: React.ReactNode | string | JSX.Element;
};

const AccordionSummaryStyled = styled(AccordionSummary)(({ theme }) => ({
    paddingLeft: "0",
    maxHeight: "30px",
    display: "inline-flex",
    marginTop: "0 !important",
    [`& .${accordionSummaryClasses.root}`]: {
        minHeight: "0",
    },
    [`& .${accordionSummaryClasses.expanded}`]: {
        minHeight: "0",
    }
}));

const AccordionStyled = styled(Accordion)(({ theme }) => ({
    border: "none",
    boxShadow: "none",
    '&::before': {
        display: 'none',
    },
}));

const AccordionDetailsStyled = styled(AccordionDetails)(({ theme }) => ({
    display: "block",
    padding: "0",
    transition: "none",
}));


export const JobDetails = ({ children }: JobDetailsProps) => {
    return (
        <AccordionStyled className="cv-details">
            <AccordionSummaryStyled expandIcon={<ArrowDownward />}><Typography variant="h6">Einzelheiten</Typography></AccordionSummaryStyled>
            <AccordionDetailsStyled className='cv-details-content'>
                {children}
            </AccordionDetailsStyled>
        </AccordionStyled>
    );
};